
<div [formGroup]="form" *ngIf="form.controls.documents " class="col-md-12" tabindex="-1">
  <content
        formGroupName="documents{{index}}"
        *ngFor="let document of documents"
        class="sub-monetary-fee-request-file-input-1-content-1">
        <div class="container-form" *ngIf="document.description">
          <p>
            <Strong class="azul">Descripción de devolución: </Strong>
          {{document.description}}
          </p>
        </div>
        <app-upload-file
        [formControlName]="document.idForm"
        isFormData="true"
        isSave="true"
        [extPermit]="document.type"
        [maxSizeAttachmentsKb]="document.maxSizeAttachmentsKb"
        [title]="document.label"
        [required]="document.required"
        isFormData
        [nameFile]="document.label" [label]="document.label"
        [nameclassInput] = "'sub-monetary-upload-file-input-2'"
        (files)="onFileChange($event,document)"
        (attachmentsEvent)="delete($event)"
        >
        <br>
        <mat-error
            class="mtop-10"
            *ngIf="form.get('documents').get(document.idForm).invalid && (form.get('documents').get(document.idForm).touched || form.get('documents').get(document.idForm).dirty)">
            {{document.label}} es <strong>requerido</strong>
            <p *ngIf="!validateString(messageError)">{{messageError}}</p>
        </mat-error>

      </app-upload-file>
      <!-- (attachmentsEventParent) = "attachmentsChange($event)" -->
  </content>
</div>
